import { connect } from 'react-redux';
import { getAnalyticsData } from '../../selectors';
import { IState } from '../../store';
import { getAgentAvatar } from '../../utils/getAgentAvatar';
import { IPromotionsBlockStoreProps, PromotionsBlock } from './PromotionsBlock';
import { isCountrysidePromoEnabled } from '../../utils/experiments/countrysidePromotions';

export function mapStateToProps(state: IState): IPromotionsBlockStoreProps {
  const {
    kp,
    offer: { phones },
    agent,
  } = state.offerData;

  const phone = phones && phones[0] && phones[0].number ? phones[0] : null;
  const builder =
    agent && agent.companyName
      ? {
          name: agent.companyName,
          logoUrl: getAgentAvatar(agent),
        }
      : undefined;

  return {
    promotionsData: kp && kp.promotions,
    villageName: kp && kp.name,
    phone,
    analyticsData: getAnalyticsData(state),
    isEnabled: isCountrysidePromoEnabled(state),
    builder,
    kpId: state.offerData.kp && state.offerData.kp.id,
  };
}

export const CountrysidePromoBlockContainer = connect<IPromotionsBlockStoreProps>(mapStateToProps)(PromotionsBlock);
